export default __webpack_public_path__ + "static/media/mlabs.1cc37b93.svg";